// extracted by mini-css-extract-plugin
export var footer = "_oo-0";
export var inherit = "_oo-1";
export var input = "_oo-2";
export var modalContent = "_oo-3";
export var quillEditor = "_oo-4";
export var subtitle = "_oo-5";